import { inject } from 'aurelia';
import { IRouter } from '@aurelia/router';
import { UserApi } from '../../apis/user/user-api';
import { UserContext } from '../../contexts/user-context';
import { LanguageResolver } from '../../infrastructure/language-resolver';

@inject(IRouter, UserApi, UserContext, LanguageResolver)
export class OnboardingPage {
    public acceptTermsAndPrivacy: boolean = false;
    public emailMarketingConsent: boolean = false;
    public isBusy: boolean = false;
    private _returnUrl: string | null = null;

    constructor(
        private readonly _router: IRouter,
        private readonly _userApi: UserApi,
        private readonly _userContext: UserContext,
        private readonly _languageResolver: LanguageResolver,
    ) {}

    public get canSubmit(): boolean {
        return this.acceptTermsAndPrivacy;
    }

    public loading(): void {
        this._returnUrl = new URLSearchParams(window.location.search).get('returnUrl');
        // Legacy users are opted in by the 2.0 migration; show that choice instead of silently replacing it with "off".
        this.emailMarketingConsent = this._userContext.userEntity?.emailMarketingConsent ?? false;
    }

    public get termsUrl(): string {
        return `${window.location.origin}/${this._languageResolver.currentLanguage}/terms`;
    }

    public get privacyUrl(): string {
        return `${window.location.origin}/${this._languageResolver.currentLanguage}/privacy`;
    }

    public async submit(): Promise<void> {
        if (!this.canSubmit) { return; }
        this.isBusy = true;
        try {
            const updated = await this._userApi.patchConsent(
                this._userContext.userId,
                {
                    acceptTerms: true,
                    acceptPrivacy: true,
                    emailMarketingConsent: this.emailMarketingConsent,
                    concurrency: this._userContext.userEntity.concurrency,
                },
            );
            this._userContext.setUserInfo(updated);
            if (this._returnUrl) {
                void this._router.load(this._returnUrl);
            } else {
                void this._router.load('my-events');
            }
        } finally {
            this.isBusy = false;
        }
    }
}
